<form #transitProgramDriverSearchForm="ngForm" (submit)="performSearch()">
  <input
    type="text"
    class="form-control"
    name="riderSearch"
    id="riderSearch"
    [placeholder]="placeholder"
    [(ngModel)]="searchString"
    autocomplete="off"
    (keyup)="onKeyUp($event)"
    [disabled]="disabled"
    data-private="lipsum"
  />
  <button mat-raised-button color="primary" type="submit" [disabled]="!transitProgramDriverSearchForm.form.valid">
    <mat-icon></mat-icon>&nbsp;&nbsp; Search
  </button>
  <div class="transit_program_driver_search_autocomplete_container" *ngIf="searchResults && showResults">
    <mat-list>
      <mat-list-item *ngIf="searchResults && searchResults.length === 0 && searchString.length > 0">
        <div mat-line>
          <span class="autocomplete-item-text">No Drivers Found</span>
        </div>
        <mat-divider></mat-divider>
      </mat-list-item>

      <mat-list-item
        class="autocomplete-item"
        *ngFor="let transitProgramDriver of searchResults"
        (click)="selectSearchResult(transitProgramDriver)"
      >
        <span class="autocomplete-item-text" data-private>
          {{ transitProgramDriver.firstName }} {{ transitProgramDriver.lastName }} | Phone: {{ transitProgramDriver.phoneNumber | phone }}
        </span>
        <mat-divider></mat-divider>
      </mat-list-item>
    </mat-list>
  </div>
</form>
